import { render, staticRenderFns } from "./BestProductCard.vue?vue&type=template&id=178b0a10&scoped=true&"
import script from "./BestProductCard.vue?vue&type=script&lang=js&"
export * from "./BestProductCard.vue?vue&type=script&lang=js&"
import style0 from "./BestProductCard.vue?vue&type=style&index=0&id=178b0a10&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "178b0a10",
  null
  
)

export default component.exports